import type { QueueTaskNode } from '../types';
import { getDuration, useDateFormatter } from '@nexelem/utils';
import { differenceInCalendarDays, differenceInDays } from 'date-fns';

type FormatTaskDurationOptions = {
  withoutDuration?: boolean;
  compact?: boolean;
};

type TaskDates = Pick<QueueTaskNode, 'startDate' | 'endDate'>;

export const useFormatTaskDuration = ({ withoutDuration = false, compact = false }: FormatTaskDurationOptions = {}) => {
  const formatTime = useDateFormatter({ onlyHours: true });
  const formatDateTime = useDateFormatter({ displayWithHours: true });

  return ({ startDate, endDate }: TaskDates) => {
    const isLongRange = compact
      ? differenceInDays(endDate, startDate) > 0
      : differenceInCalendarDays(endDate, startDate) > 0;

    const start = !compact || isLongRange ? formatDateTime(startDate) : formatTime(startDate);
    const end = isLongRange ? formatDateTime(endDate) : formatTime(endDate);
    const range = `${start} - ${end}`;

    if (withoutDuration) {
      return range;
    }

    const duration = getDuration(startDate, endDate, ['seconds']);
    return duration ? `${range} (${duration})` : range;
  };
};
